class TimeZoneCollection extends App.Collections.BaseCollection {
    url = 'TimeZone';
    model = App.Models.TimeZone;
}

App.Collections.TimeZones = TimeZoneCollection;
